import { motion } from "framer-motion";
import { Logo } from "@/components/lunar/Logo";

export const VenueHero = ({ onCta }) => (
    <section data-testid="venue-hero" className="mx-auto max-w-6xl px-6 pb-16 pt-20 sm:pt-24">
        <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="text-[11px] font-medium uppercase tracking-[0.28em] text-[#899B6A]"
        >
            For venues
        </motion.p>
        <h1
            data-testid="venue-hero-heading"
            className="font-display mt-5 max-w-3xl text-[2.7rem] font-medium leading-[1.06] tracking-tight text-[#1D201A] sm:text-6xl"
        >
            {["Get Lunar", "at your venue."].map((line, i) => (
                <span key={i} className="block overflow-hidden pb-1">
                    <motion.span
                        className="block"
                        initial={{ y: "112%" }}
                        animate={{ y: "0%" }}
                        transition={{ duration: 0.9, delay: 0.1 + i * 0.13, ease: [0.22, 1, 0.36, 1] }}
                    >
                        {i === 1 ? (
                            <>
                                at your <em className="italic text-[#4A5D23]">venue</em>.
                            </>
                        ) : (
                            line
                        )}
                    </motion.span>
                </span>
            ))}
        </h1>
        <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
            <p className="mt-7 max-w-xl text-lg leading-relaxed text-[#3E413B]">
                Get Lunar materials for your permanent venue and help the people already there
                connect in real life.
            </p>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-[#5C5F58]">
                For pubs, cafés, universities, Build to Rent developments, hotels, gyms,
                coworking spaces and other shared places.
            </p>
            <button
                data-testid="venue-hero-cta"
                onClick={onCta}
                className="mt-9 inline-flex items-center rounded-full bg-[#2C3618] px-7 py-3.5 text-sm font-bold text-[#F9F8F4] transition-[background-color,transform] duration-300 hover:-translate-y-[2px] hover:bg-[#4A5D23]"
            >
                Choose your Lunar kit
            </button>
            <p
                data-testid="venue-worldwide-note"
                className="mt-4 text-[11px] font-medium uppercase tracking-[0.22em] text-[#899B6A]"
            >
                Available worldwide
            </p>
        </motion.div>
    </section>
);

export const VenueHeader = () => (
    <header className="mx-auto flex max-w-6xl items-center justify-between px-6 pt-7">
        <a href="/" aria-label="Back to Lunar home" data-testid="venue-back-home">
            <Logo size={38} />
        </a>
        <span
            data-testid="venue-header-tagline"
            className="text-sm font-medium text-[#5C5F58]"
        >
            The social network for real life.
        </span>
    </header>
);

export const PillsHeader = ({
    links = [
        { label: "For events", href: "/events", testId: "pills-header-events" },
        { label: "For venues", href: "/venue-kit", testId: "pills-header-venues" },
        { label: "Safety →", href: "/safety", testId: "pills-header-safety" },
    ],
}) => (
    <header className="mx-auto flex max-w-6xl flex-col items-start gap-4 px-6 pt-7 sm:flex-row sm:items-center sm:justify-between">
        <a href="/" aria-label="Back to Lunar home" data-testid="pills-header-home">
            <Logo size={38} />
        </a>
        <div className="flex flex-wrap items-start gap-2 sm:flex-row sm:items-center">
            {links.map(({ label, href, testId }) => (
                <a
                    key={href}
                    href={href}
                    data-testid={testId}
                    className="flex items-center rounded-full border border-[#C2C0B8] px-3 py-2 text-[11px] font-medium text-[#3E413B] transition-[border-color,color,transform] duration-300 hover:-translate-y-[1px] hover:border-[#899B6A] hover:text-[#2C3618] sm:px-4 sm:text-xs"
                >
                    <span className="whitespace-nowrap">{label}</span>
                </a>
            ))}
        </div>
    </header>
);
